


import React, { useState } from "react";
import { motion } from "framer-motion";
import { toast } from "react-toastify";
import { useSendEnquiryMutation } from "../../slices/admin/admin"; // adjust import path
import styles from "../../assets/scss/WebHomePagesscss/WebContact.module.scss";

const floatAnimation = {
  y: [0, -10, 0],
  transition: {
    duration: 4,
    repeat: Infinity,
    ease: "easeInOut",
  },
};

const TAGS = [
  "I want to schedule a demo",
  "I want to know more about CropWork",
  "Help me with pricing details",
  "I have a question about a feature",
  "know more about a feature",
];

const WebContact = () => {
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [selectedTags, setSelectedTags] = useState([]);
  const [sendEnquiry, { isLoading }] = useSendEnquiryMutation();

  const toggleTag = (tag) => {
    setSelectedTags((prev) =>
      prev.includes(tag) ? prev.filter((t) => t !== tag) : [...prev, tag]
    );
  };

  const validate = () => {
    if (!name.trim()) {
      toast.error("Please enter your name or company name.");
      return false;
    }

    if (!phone.trim()) {
      toast.error("Please enter your phone number.");
      return false;
    }

    // ✅ must be 10 digits and start with 6–9
    if (!/^[6-9]\d{9}$/.test(phone)) {
      toast.error("Please enter a valid 10-digit phone number starting with 6–9.");
      return false;
    }

    if (email && !/^\S+@\S+\.\S+$/.test(email)) {
      toast.error("Please enter a valid email address.");
      return false;
    }

    if (!message.trim() && selectedTags.length === 0) {
      toast.error("Please select at least one topic or write a message.");
      return false;
    }

    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    const tagPart = selectedTags.join(", ");
    const fullQuery = tagPart
      ? message
        ? `${tagPart} — ${message}`
        : tagPart
      : message;

    const payload = {
      name: name.trim(),
      phone: phone.trim(),
      email: (email || "").trim(),
      query: fullQuery,
    };

    try {
      const res = await sendEnquiry(payload).unwrap();
      toast.success(res?.message || "Enquiry submitted successfully!");

      // Reset form
      setName("");
      setPhone("");
      setEmail("");
      setMessage("");
      setSelectedTags([]);
    } catch (err) {
      console.error("Send enquiry error:", err);
      toast.error(err?.data?.message || "Failed to submit enquiry.");
    }
  };

  return (
    <section className={styles.contactSection}>
      <div className={styles.container}>

          {/* RIGHT SECTION (Form) */}
        <motion.form
          className={styles.formBox}
          onSubmit={handleSubmit}
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.3 }}
          animate={floatAnimation}
        >
          <label>
            Your Name or Company Name*
            <input
              type="text"
              placeholder="Enter your name"
              required
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </label>

          <label>
            Phone Number*
            <input
              type="tel"
              placeholder="Enter phone number"
              required
              value={phone}
              onChange={(e) => {
                // ✅ Allow only digits and restrict to 10
                const value = e.target.value.replace(/\D/g, "");
                if (value.length <= 10) setPhone(value);
              }}
              onBlur={() => {
                if (phone && !/^[6-9]\d{9}$/.test(phone)) {
                  toast.error(
                    "Please enter a valid 10-digit phone number starting with 6–9."
                  );
                }
              }}
            />
          </label>

          <label>
            Your Email
            <input
              type="email"
              placeholder="Enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </label>

          <label>
            Your message to us!
            <div className={styles.tags}>
              {TAGS.map((tag) => {
                const active = selectedTags.includes(tag);
                return (
                  <button
                    type="button"
                    key={tag}
                    className={`${styles.tag} ${
                      active ? styles.tagActive : ""
                    }`}
                    onClick={() => toggleTag(tag)}
                  >
                    {tag}
                  </button>
                );
              })}
            </div>
          </label>

          <textarea
            placeholder="Type your message..."
            rows="3"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
          />

          <motion.button
            type="submit"
            whileHover={{
              scale: 1.05,
              boxShadow: "0 6px 12px rgba(84,135,49,0.3)",
            }}
            whileTap={{ scale: 0.97 }}
            className={styles.submitBtn}
            disabled={isLoading}
          >
            {isLoading ? "Sending..." : "Let’s talk"}
          </motion.button>

          <p className={styles.note}>
            You’ll hear from us within 2 hours (during business hours). Your info
            is safe and will never be shared.
          </p>
        </motion.form>
        {/* LEFT SECTION (Info) */}
        <motion.div
          className={styles.left}
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          animate={floatAnimation}
        >
          <h2>Get in touch with us</h2>
          <p>
            Get help with pricing plans, schedule a demo, explore use-cases for
            your business, and more.
          </p>

          <div className={styles.contactInfo}>
            <h4>Contact Information</h4>
            <p>Reach out to sales. We respond fast!</p>

            <div className={styles.infoItem}>
              <i className="fab fa-whatsapp"></i>
              <span>+91 6385161611</span>
            </div>

            <div className={styles.infoItem}>
              <i className="far fa-envelope"></i>
              <span>contact@cropwork.in</span>
            </div>
          </div>
        </motion.div>

      
      </div>
    </section>
  );
};

export default WebContact;


